<template>
  <div class="population-analysis" :class="className" v-inview="{ callback: onInview }">
    <ul class="population-analysis__list">
      <li class="population-analysis__item">每 3 個選民，就有 1 個是年輕人</li>
      <li class="population-analysis__item">2016 年未滿 40 歲的青年族群總選票約 702 萬，蔡英文當年得票數約 689 萬，顯見年輕選民確實具有翻轉選情的影響力。</li>
    </ul>
    <small class="population-analysis__annountation">（資料來源：內政部；本文自行整理）</small>
  </div>
</template>

<script>
export default {
  name: 'PopulationAnalysis',
  data () {
    return {
      isInview: false
    }
  },
  computed: {
    className () {
      return {
        'population-analysis--inview': this.isInview
      }
    }
  },
  methods: {
    onInview () {
      this.isInview = true
    }
  }
}
</script>

<style lang="scss">
.population-analysis {
  $comp: &;

  &__list {
  }

  &__item {
    position: relative;
    padding-left: 24px;
    color: #1a1a1a;
    font-size: 0.875em;
    font-weight: 600;
    line-height: 1.286em;
    letter-spacing: 0.1em;
    opacity: 0;
    transform: translateY(10px);
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1em;
      line-height: 1.375em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1.125em;
      line-height: 1.222em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      font-size: 1.125em;
      line-height: 1.444em;
    }

    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 5px;
      left: 5px;
      width: 8px;
      height: 8px;
      background: #e9a8a2;
      transform: rotate(45deg);
      @include rwd($RWD_DESKTOP_WIDE) {
        top: 8px;
      }
    }

    &:first-child {
      color: #d1725f;
    }

    & + & {
      margin-top: 15px;
    }
  }

  &__annountation {
    display: block;
    margin: 20px 0;
    color: #a1a1a1;
    font-size: 0.875em;
    font-weight: 600;
    text-align: center;
    letter-spacing: 0.1em;
    opacity: 0;
    transform: translateY(10px);
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1.125em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      font-size: 1em;
      text-align: left;
      text-indent: 15px;
    }
  }

  &--inview {
    #{$comp}__item {
      opacity: 1;
      transform: translateY(0);
      transition:
        opacity 0.4s,
        transform 0.4s;

      &:nth-child(1) {
        transition-delay: 0s;
      }

      &:nth-child(2) {
        transition-delay: 0.4s;
      }

      &:nth-child(3) {
        transition-delay: 0.8s;
      }

      &:nth-child(4) {
        transition-delay: 1.2s;
      }
    }
    #{$comp}__annountation {
      opacity: 1;
      transform: translateY(0);
      transition:
        opacity 0.4s ease 1.6s,
        transform 0.4s ease 1.6s;
    }
  }
}
</style>
